import React, { useState, useEffect, useMemo } from "react";
import SideNavClass from './SideNavClass';
import { isMobile } from 'react-device-detect';
import moment from "moment";
import { MDBAlert, MDBSelect, MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBCardText, MDBCardTitle, MDBChip, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBPopconfirm, MDBPopconfirmMessage, MDBTypography, MDBInput } from "mdb-react-ui-kit";
// import ReactFullCalender from "./ReactFullCalender";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
// import { INITIAL_EVENTS } from "./event-utils";
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'; // Import the default styles for the tooltip
import copy from 'clipboard-copy';
import { idToSlug } from "../../utils/slug";
import { getAllSubDomain, getGBussinessInfo, getMembersBySchedule, logEvent, getWaiverSettingsbyGymid } from "../../services/classApiServices";

import ExcelExportButton from "../../components/exportToExcel";
import { browserName, browserVersion } from "react-device-detect";
import { sendMemberwaiverUrl } from "../../services/memberApiServices";
// import { getWaiverSettingsbyGymid } from "../../services/apiServices";
import { useAccess } from "../../context/AccessContext";


const ClassesBooking = ({ classes, scheduleInfo, trainerData, policyData, editCallback, deleteCallback, plans, handlealertDelete, toggleOpen }) => {
    const [schedulModal, setscheduModal] = useState(false);
    const scheduleopen = () => setscheduModal(!schedulModal);

    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const [weekendsVisible, setWeekendsVisible] = useState(true)

    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () => setDeleteModal(!deleteModal);
    const [eventdata, setEventdata] = useState(null)
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDateEvents, setSelectedDateEvents] = useState([]);
    const [selectedDate, setSelectDate] = useState(null)
    const toggleModal = () => setModalOpen(!modalOpen);
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    const isAdmin = loggedUserInfo?.role !== "staff";
    const [classbookingurl, setClassbookingurl] = useState("")
    const [filteredClassIds, setFilteredClassIds] = useState([]);
    const [filteredTrainerIds, setFilteredTrainerIds] = useState([]);
    const [selectKey, setSelectKey] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [basicData, setBasicData] = useState({ columns: [], rows: [] });

    const { loading, handlePageAccess, handleClassPageAssess } = useAccess();
    const roleAccess = handleClassPageAssess("schedules")
    const recurrence = eventdata?.extendedProps?.scheduleinfo?.recurrence || {};
    const recurrencetype = recurrence?.recurrencetype;

    const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
    const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    let recurrenceText = "";


    if (recurrence.type === "monthly") {
        let weeks = recurrence.value || [];
        let days = recurrence.subvalue || [];

        const allWeeks = weeks.includes(-1);
        const allDays = days.includes(-1);

        const weekText = allWeeks
            ? "every week"
            : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

        const dayText = allDays
            ? "all days"
            : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

        if ((allWeeks || weeks.length) && (allDays || days.length)) {
            if (allWeeks) {
                recurrenceText = `Every week on ${dayText} at ${eventdata?.extendedProps?.startTimeNew} – ${eventdata?.extendedProps?.endTimeNew}`;
            } else {
                recurrenceText = `Every  ${weekText} of the month on ${dayText} at ${eventdata?.extendedProps?.startTimeNew} – ${eventdata?.extendedProps?.endTimeNew}`;
            }
        }
    } else if (recurrence.type === "weekly") {
        let days = recurrence.value || [];

        const allDays = days.includes(-1);

        const dayText = allDays
            ? "all days"
            : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

        if (days.length || allDays) {
            recurrenceText = `Every week on ${dayText} at ${eventdata?.extendedProps?.startTimeNew} – ${eventdata?.extendedProps?.endTimeNew}`;
        }
    }
    else {
        // For onetime or unknown types
        recurrenceText = `${eventdata?.extendedProps?.startTimeNew} – ${eventdata?.extendedProps?.endTimeNew}`;
    }



    const handleEdit = () => {
        console.log(eventdata?.extendedProps?.scheduleinfo);

        editCallback(eventdata?.extendedProps?.scheduleinfo)
        // setEventdata(event)
    }

    // const handlealertDelete = () => {
    //     setDeleteModal(true)
    // }
    const deleteAlert = (id) => {
        scheduleopen();
        handlealertDelete(id)
    }


    const confirmDelete = async (e, isapply) => {
        console.log('0000000000000000000000');
        deleteCallback(eventdata?.scheduleinfo?._id, isapply)
        // const res = await deleteClass(JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid, classid)
        // setRefresh(true)
        setDeleteModal(false)
    }
    const handleShare = async () => {
        try {
            const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);

            let shareUrl;

            const apiUrl = process.env.REACT_APP_PRIMARY_SERVER_URL;
            const baseUrl = apiUrl.replace(/\/api\/?$/, "");
            console.log(baseUrl, 'baseUrl');
            console.log(`${baseUrl}/booking/${slug}`, '00000');
            // if (currentdomain.status == 3) {
            // shareUrl = `${baseUrl}/booking/${slug}`;
            shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;
            // } else {
            // shareUrl = `${window.location.origin}/booking?id=${classbookingurl}&sid=${slug}`
            // }

            if (navigator.share) {
                await navigator.share({
                    title: eventdata?.title || 'Event Invitation',
                    text: [
                        `Join me for: ${eventdata?.title}`,
                        eventdata?.extendedProps?.date && `When: ${eventdata?.extendedProps?.date}`,
                        eventdata?.extendedProps?.location && `Where: ${eventdata?.extendedProps?.location}`,
                        eventdata?.extendedProps?.trainer && `Host: ${eventdata?.extendedProps?.trainer}`,
                        eventdata?.extendedProps?.description && `Details: ${eventdata?.extendedProps?.description}`
                    ].filter(Boolean).join('\n\n'),
                    url: shareUrl
                });
            }
        } catch (err) {
            console.log('Share failed:', err);
        }
    };

    const handlecopyDomainuserUrl = () => {
        const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);
        let shareUrl;

        const apiUrl = process.env.REACT_APP_PRIMARY_SERVER_URL;
        const baseUrl = apiUrl.replace(/\/api\/?$/, "");
        console.log(baseUrl, 'baseUrl');
        console.log(`${baseUrl}/booking/${slug}`, '00000');
        // if (currentdomain.status == 3) {
        // shareUrl = `${baseUrl}/booking/${slug}`;
        shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;
        // } else {
        // shareUrl = `${window.location.origin}/booking?id=${classbookingurl}&sid=${slug}`
        // }

        // const shareUrl = currentdomain.status == 3 ? `https://${currentdomain.subdomain}.${mainDomain}/availablesessions?sid=${slug}` : `${window.location.origin}/booking?id=${classbookingurl}&sid=${slug}`

        copy(shareUrl);
        console.log("Share URL:", shareUrl);
        // copy(shareUrl)
        setcopyLink(true);
    }

    const isFutureEvent = () => {

        const endDate = new Date(eventdata?.end);

        const combinedEndDateTime = moment(endDate)
            .set({
                hour: moment(eventdata?.endTime, "hh:mm A").hour(),
                minute: moment(eventdata?.endTime, "hh:mm A").minute(),
                second: 0,
            })
            .toDate();

        return new Date() < combinedEndDateTime;
    };

    function encryptId(id) {
        return btoa(id);
    }
    const [sendLink, setSendLink] = useState(false)

    const [waiverid, setWaiverid] = useState("")
    async function fetchWaiverData() {

        const waiverRes = await getWaiverSettingsbyGymid(
            JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
        );
        if (waiverRes === "false") {
            // setApiError(true)
        } else {
            const waiver = await waiverRes.json();
            console.log(waiver);

            let uniqueId = waiver?.uniqueNumber;
            setWaiverid(uniqueId)


        }
    }


    useEffect(() => {
        fetchWaiverData()
    }, [])
    const [linkstatus, setLinkstatus] = useState("")
    const handleWaiverlink = async (memberid) => {

        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        const update = {
            link: link,
            id: memberid,
            gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
            centername: "testing"
        }
        const response = await sendMemberwaiverUrl(update)
        const data = await response.json();
        console.log(data, "data");
        if (data.success) {
            setLinkstatus('success')
        } else {
            setLinkstatus("danger")
        }
        setSendLink(true)
    }

    const handlecopyUrl = (memberid) => {
        const slug = idToSlug(memberid);
        console.log(slug, 'slug');
        let uniqueId = waiverid;
        const encryptedId = encryptId(uniqueId);
        const link = `${window.location.origin}/waiver?id=${encryptedId}&mId=${slug}`
        console.log(link, 'link');
        copy(link);

        setcopyLink(true);

    }

    const generateTableData = (data) => {
        if (!data || !Array.isArray(data.tableData)) return { columns: [], rows: [] };

        const columns = [
            "S.no", "Order Id", "Member(s)", "Number", "Age", "Gender", "Class Name",
            "Start Date", "End Date", "Plan Price", "Total Amount(incl.tax)",
            "Refund Amount", "Mode", "Waiver"
        ];
        const rows = data.tableData.map((entry) => [
            entry.sno || "-",
            entry.orderId || "-",
            entry.membername || "-",
            entry.number || "-",
            entry.age || "--",
            entry.gender || "--",
            entry.className || "-",
            new Date(entry.startDate).toLocaleString("en-IN"),
            new Date(entry.endDate).toLocaleString("en-IN"),
            entry.planPrice || "-",
            entry.actualPrice || "-",
            entry.refundAmount || "0",
            entry.mode || "Offline",
            entry.iswaiververified ? "Submitted" : <div className='d-flex align-items-center'>
                <div >
                    <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                        onClick={() => handlecopyUrl(entry.id)}
                    ><i class="fa-regular fa-copy "></i></span>
                    <MDBBtn size="sm" className="ms-2" onClick={() => handleWaiverlink(entry.id)}>send</MDBBtn>
                </div>
            </div >
        ]);

        return { columns, rows };
    };


    const fetchMembersBySchedule = async (scheduleId) => {
        try {
            const updates = {
                gymid: JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
                scheduleId: scheduleId
            };
            const res = await getMembersBySchedule(scheduleId, updates);
            if (!res || res === "false") {
                return
            }
            const data = await res.json();
            console.log("Fetched Schedule Data:", data);
            setBasicData(generateTableData(data));
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching schedule data:", error);
        }
    };

    const handleclick = (eventData) => {
        const scheduleId = eventData.extendedProps.scheduleinfo._id;
        fetchMembersBySchedule(scheduleId);
    };


    const downloadtabledata = (data) => {
        if (!data || !data.columns || !data.rows) {
            console.warn("No valid data to export");
            return;
        }
        const clonedData = {
            ...data,
            rows: data.rows.map((row) =>
                row.map((cell, index) => {
                    // For the last column (Waiver)
                    const isLastColumn = index === data.columns.length - 1;

                    // Replace React element or object-like value with "Not Submitted"
                    if (isLastColumn && (typeof cell === "object" || typeof cell === "function")) {
                        return "Not Submitted";
                    }

                    return cell;
                })
            ),
        };
        const fileName = `Schedule_Members_${new Date().toLocaleDateString("en-IN").replace(/\//g, "-")}`;
        ExcelExportButton(clonedData, fileName);
    };


    const classOptions = Array.isArray(classes) && classes.length > 0
        ? classes
            .filter(cls => cls && cls.name && cls._id)
            .map(cls => ({
                text: cls.name,
                value: cls._id
            }))
        : [];

    const trainerOptions = Array.isArray(trainerData) && trainerData.length > 0
        ? trainerData
            .filter(tr => tr && tr.firstname && tr.lastname && tr._id)
            .map(tr => ({
                text: `${tr.firstname} ${tr.lastname}`,
                value: tr._id
            }))
        : [];


    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    useEffect(() => {
        if (isMobile) {
            setModeOpen(false);
            setMode("over");
        }
    }, []);

    useEffect(() => {
        let getLoggedInGymInfo = async () => {
            try {
                const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                const response = await getGBussinessInfo(gymid);

                if (!response || response === "false") {
                    return
                }

                const recinfo = await response.json();
                setClassbookingurl(recinfo?.classbookingurl)
            } catch (e) { }

        };

        getLoggedInGymInfo();
        fetchsubDomains()
    }, []);

    const sideNav = () => {
        setModeOpen(!modeOpen);
        setMode(isMobile ? "over" : "side");
    };
    console.log(classes, scheduleInfo, trainerData, policyData, '9999999999999999999999');

    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }

    const mainDomain = getMainDomain(window.location.hostname);
    const [subdomain, setSubdomain] = useState("")
    const [currentdomain, setCurrentdomain] = useState({})
    async function fetchsubDomains() {
        const gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : -1;
        // const url = new URL("https://easymembr.com/classesbusiness");
        // const url = new URL("https://zencruz.com/classesbusiness")
        // const hostname = url.hostname;

        // const Domain = getMainDomain(hostname);
        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();
        console.log(subDomainData, '999999999999999999999');
        // setSubDomainData(subDomainData);


        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setSubdomain(matchedDomain.subdomain)
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
        // setRefresh(false)
    }

    const getEvents = () => {
        if (!Array.isArray(scheduleInfo) || !Array.isArray(classes) || !Array.isArray(trainerData) || !Array.isArray(policyData)) {
            return [];
        }

        const adjustStartWithTimeslot = (start, timeslot) => {



            if (!start || !timeslot) return new Date(start);

            const base = moment(start);

            const slotMoment = moment(timeslot, "hh:mm A");

            // Compare
            if (base.hour() === slotMoment.hour() && base.minute() === slotMoment.minute()) {
                // Times already match → just return backend date
                return base.toDate();
            }

            // Replace only time with slot
            const fixed = moment(base.format("YYYY-MM-DD") + " " + timeslot, "YYYY-MM-DD hh:mm A");
            return fixed.toDate();
        };



        return scheduleInfo
            .filter(schedule => schedule && schedule.classid && schedule.startdate && schedule.enddate)
            .map(schedule => {
                const classInfo = classes.find(cls => cls?._id === schedule.classid) || {};
                const trainer = trainerData.find(tr => tr?._id === schedule.trainerid) || {};
                const policy = policyData.find(pol => pol?._id === schedule.cancellationpolicyid) || {};

                // Filter out inactive classes
                // if (!isActiveClass(schedule, classInfo)) {
                //     return null;
                // }

                const duration = parseInt(classInfo.duration, 10) || 0;

                const startMoment = moment(schedule?.timeslot, "hh:mm A");
                const endMoment = startMoment.clone().add(duration, 'minutes');
                const cancellationPolicy = policy?.cancelfee?.filter(fee => fee.checked) || [];
                const membership = classInfo?.membershipdiscount?.filter(d => d.checked) || [];

                // const data = schedule.startdate??asdfsdf:""

                const mergedStart = adjustStartWithTimeslot(schedule.startdate, schedule?.timeslot);


                let eventDates = [];

                eventDates.push({
                    title: classInfo.name || "Unknown Class",
                    start: mergedStart,
                    end: new Date(schedule.enddate),
                    trainer: trainer?.firstname ? trainer.firstname + " " + trainer.lastname : "Unknown Trainer",
                    slotsBooked: schedule.bookedslots || 0,
                    slotsRemaining: schedule.totalslots || 0,
                    startTimeNew: startMoment.format("hh:mm A"),
                    endTimeNew: endMoment.format("hh:mm A"),
                    cancellationPolicy: cancellationPolicy,
                    eventType: !schedule.onetime ? `Recurring(${schedule?.recurrence?.recurrencetype})` : "One-Time",
                    location: schedule?.location,
                    description: classInfo.description ? classInfo.description : '--',
                    membershipdiscount: membership,
                    scheduleinfo: schedule,
                    isActive: true,
                    isprivate: schedule?.isprivate ? schedule.isprivate : false
                });

                return eventDates;
            })
            .filter(event => event !== null)
            .flat();
    };

    useEffect(() => {
        const allEvents = getEvents();
        setSelectedDateEvents(allEvents);
    }, [scheduleInfo, classes, trainerData, policyData]);

    const allEvents = getEvents();

    let eventinfo = allEvents;
    if (filteredClassIds.length > 0 || filteredTrainerIds.length > 0) {
        const filteredSchedules = allEvents.filter((event) => {
            const classId = event?.scheduleinfo?.classid;
            const trainerId = event?.scheduleinfo?.trainerid;
            const classMatch = filteredClassIds.length > 0 ? filteredClassIds.includes(classId) : true;
            const trainerMatch = filteredTrainerIds.length > 0 ? filteredTrainerIds.includes(trainerId) : true;
            return classMatch && trainerMatch && event.isActive;
        });

        eventinfo = filteredSchedules;
    } else {
        eventinfo = allEvents.filter(event => event.isActive);
    }

    useEffect(() => {
        setSelectedDateEvents(eventinfo);
    }, [filteredClassIds, filteredTrainerIds, scheduleInfo, classes, trainerData, policyData]);

    // console.log(selectedDateEvents, '888888888888888', INITIAL_EVENTS);

    const [eventInfo, seteventInfo] = useState({})
    const [copyLink, setcopyLink] = useState(false);
    const EventCard = ({ event: eventInfo }) => {

        if (!eventInfo) {
            return null;
        }

        // Extract actual event data from FullCalendar event object
        const event = eventInfo.event;

        if (!event) {
            return null;
        }

        const handleEdit = () => {
            console.log(event.extendedProps.scheduleinfo);

            editCallback(event.extendedProps.scheduleinfo)
            // setEventdata(event)
        }

        // const handlealertDelete = () => {
        //     setDeleteModal(true)
        // }
        const deleteAlert = (id) => {
            handlealertDelete(id)
        }


        const confirmDelete = async (e, isapply) => {
            const user = JSON.parse(localStorage.getItem("loggedUserInfo"));
            const fullName = user?.name || `${user?.fname || ""} ${user?.lname || ""}`.trim() || "User";
            const username1 = user.email || "Guest";
            const ip = localStorage.getItem("ipaddress");
            const browserinfo = `${browserName}-${browserVersion}.0.0`;
            const gymid = user?.gymid;
            const scheduleId = event?.scheduleinfo?._id;

            try {
                await deleteCallback(scheduleId, isapply);

                const flag = `Schedule (${fullName}) deleted successfully`;

                await logEvent({
                    Eventtype: username1,
                    username1,
                    fullName,
                    ip,
                    flag,
                    browserinfo,
                    isclass: true
                }, gymid);

                // Close modal and refresh
                setDeleteModal(false);
            } catch (err) {
                console.error("Failed to delete schedule or log event:", err);
            }
        };


        const recurrence = event.extendedProps?.scheduleinfo?.recurrence || {};
        const recurrencetype = recurrence?.recurrencetype;

        const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
        const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        let recurrenceText = "";


        if (recurrencetype === "monthly") {
            let weeks = recurrence.value || [];
            let days = recurrence.subvalue || [];

            const allWeeks = weeks.includes(-1);
            const allDays = days.includes(-1);

            const weekText = allWeeks
                ? "every week"
                : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if ((allWeeks || weeks.length) && (allDays || days.length)) {
                if (allWeeks) {
                    recurrenceText = `Every week on ${dayText} at ${event.extendedProps.startTimeNew} – ${event.extendedProps.endTimeNew}`;
                } else {
                    recurrenceText = `Every  ${weekText} of the month on ${dayText} at ${event.extendedProps.startTimeNew} – ${event.extendedProps.endTimeNew}`;
                }
            }
        }
        else if (recurrencetype === "weekly") {
            let days = recurrence.value || [];

            const allDays = days.includes(-1);

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if (days.length || allDays) {
                recurrenceText = `Every week on ${dayText} at ${event.extendedProps.startTimeNew} – ${event.extendedProps.endTimeNew}`;
            }
        }
        else {
            // For onetime or unknown types
            recurrenceText = `${event?.extendedProps?.startTimeNew} – ${event?.extendedProps?.endTimeNew}`;
        }



        const handleEventClick = () => {
            setEventdata(event)
            scheduleopen()
        }
        return (
            <div className='w-100'>

                <div
                    className='d-flex align-items-start justify-content-center w-100 flex-column bg-success bg-opacity-25 py-1 px-2 custom-card'
                    onClick={handleEventClick}
                    style={{
                        borderRadius: "5px",
                        color: "#000",
                        textTransform: "capitalize",
                        zIndex: "1000"
                    }}
                >
                    <div className='d-flex align-items-center slot-time'>
                        <div> <strong>{event.title}  :  </strong> </div>
                        <p className='mb-0 ms-2'> {event.extendedProps.startTimeNew} to {event.extendedProps.endTimeNew}</p>
                    </div>

                    <p className="m-0 text-dark">
                        {event.extendedProps.slotsBooked}/{event.extendedProps.slotsRemaining} Booked
                    </p>
                    <div className="w-100 text-end">
                        <label>  <i class="fas fa-user me-1"></i>
                            {event?.extendedProps?.trainer ? event?.extendedProps?.trainer : "UnKnown Name"}</label>
                    </div>

                </div>


            </div >
        );
    };

    const validatedEvents = useMemo(() => {
        return selectedDateEvents.filter((event) => event && event.start && event.end);
    }, [selectedDateEvents]);

    const dayPropGetter = (date) => {
        return {
            style: {
                maxHeight: "250px",
                overflowX: "auto",
            },
        };
    };

    const handleDateClick = (arg) => {
        console.log('date', arg);
        if ((localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin") {
            if (new Date(arg?.date) > new Date()) {
                setSelectDate(arg?.date)
                editCallback(null, arg?.date)
            }
        }

    };
    const handleeventChange = (arg) => {
        console.log(arg);

    }
    return (
        <>
            <div className="position-relative">
                <div className="d-flex flex-wrap align-items-end gap-3 filter-table mt-3">

                    <div >
                        <MDBSelect
                            key={`class-select-${selectKey}`}
                            clearButton
                            data={classOptions}
                            label="Filter Classes"
                            multiple
                            search
                            selected={classOptions.filter(opt => filteredClassIds.includes(opt.value))}
                            onChange={(values) => {
                                const selectedValues = values ? values.map(item => item.value) : [];
                                setFilteredClassIds(selectedValues);
                            }}

                        />
                    </div>

                    <div >
                        {/* <label><strong>Filter by Trainer</strong></label> */}
                        <MDBSelect
                            key={`trainer-select-${selectKey}`}
                            clearButton
                            data={trainerOptions}
                            label="Filter Trainers"
                            multiple
                            search
                            selected={trainerOptions.filter(opt => filteredTrainerIds.includes(opt.value))}
                            onChange={(values) => {
                                const selectedValues = values ? values.map(item => item.value) : [];
                                setFilteredTrainerIds(selectedValues);
                            }}
                        />
                    </div>
                </div>

                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                    }}
                    initialView='dayGridMonth'
                    // editable={true}
                    selectable={true}
                    selectMirror={true}
                    dayMaxEvents={true}
                    weekends={weekendsVisible}
                    // initialEvents={selectedDateEvents && selectedDateEvents.length > 0 ? selectedDateEvents : []}
                    events={selectedDateEvents}
                    eventContent={(arg) => <EventCard event={arg} />}
                    select={toggleOpen}
                    // eventContent={EventCard}

                    // eventsSet={handleEvents} // called after events are initialized/added/changed/removed
                    height={'calc(100vh - 150px)'}
                    dateClick={handleDateClick}
                // eventRemove={handleeventChange}
                // eventChange={handleeventChange}
                /* you can update a remote database when these fire:
                eventAdd={function(){}}
                // eventChange={function(){}}
                // eventRemove={function(){}}
                */
                />
            </div>


            {showModal && (
                <MDBModal open={showModal} setOpen={setShowModal} tabIndex="-1" className="schedule_modal">
                    <MDBModalDialog size="xl">
                        <MDBModalContent className="schedule-modal-content">
                            <MDBModalHeader>
                                <MDBModalTitle>Scheduled Members </MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => setShowModal(false)} />
                            </MDBModalHeader>

                            <MDBModalBody>
                                <div className="schedule-members-table-wrapper">
                                    {basicData?.rows?.length > 0 ? (
                                        <table className="table table-bordered table-striped custom-scroll-table">
                                            <thead className="table-header">
                                                <tr>
                                                    {basicData?.columns.map((col, idx) => (
                                                        <th key={idx}>{col}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {basicData?.rows.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        {row.map((cell, colIndex) => (
                                                            <td key={colIndex}>{cell}</td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="text-center">
                                            <h5 className="text-danger">There are no bookings for this class yet.</h5>
                                        </div>
                                    )}
                                </div>
                            </MDBModalBody>

                            <MDBModalFooter className="pe-4 pb-3">
                                <MDBBtn color="secondary" onClick={() => setShowModal(false)}>Close</MDBBtn>
                                <MDBBtn className="ms-2" onClick={() => downloadtabledata(basicData)}>
                                    <MDBIcon fas icon="download" className="d-inline me-1" />download
                                </MDBBtn>

                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            )}

            <MDBModal open={schedulModal} onClose={() => setscheduModal(false)} tabIndex='-1'>
                <MDBModalDialog size="lg">
                    <MDBModalContent style={{ maxHeight: '70%' }}>
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag='h6' className="m-0 p-0">
                                    {eventdata?.title}
                                </MDBTypography>
                                <div className='d-flex align-items-center'>
                                    <div >
                                        <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                                            onClick={handlecopyDomainuserUrl}
                                        ><i class="fa-regular fa-copy "></i></span>
                                        {/* {navigator.share && ( */}
                                        <span className='share fw-300  cursor-pointer me-2  primary-icon' title="share"
                                            onClick={() => handleShare(eventdata)}
                                        >
                                            <MDBIcon fas icon="share-alt" />
                                        </span>
                                        {/* )} */}
                                    </div>

                                    {isFutureEvent() && roleAccess?.editevent !== 2 && (<>
                                        <MDBIcon icon="edit" className=' fs-6 text-primary cursor-pointer me-2' title="Edit" onClick={handleEdit} />
                                        <MDBIcon icon="trash" className='fs-6 text-danger  cursor-pointer' title="Trash"
                                            //  onClick={handlealertDelete}
                                            onClick={() => {
                                                console.log(eventdata);

                                                deleteAlert(eventdata?.extendedProps?.scheduleinfo?._id)
                                            }
                                            }
                                        />
                                    </>)}
                                    <MDBBtn className='btn-close ms-3' color='none' onClick={scheduleopen}></MDBBtn>
                                </div>
                            </div>
                        </MDBModalHeader>
                        <MDBModalBody className='p-3'
                            onClick={() => handleclick(eventdata)}
                            style={{ cursor: "pointer" }}>

                            <table className="table table-striped table-bordered compressed-table mb-0">
                                <tbody>
                                    <tr>
                                        <td width="150px">Time</td>
                                        <td> {recurrenceText}</td>
                                    </tr>
                                    <tr>
                                        <td>  Host</td>
                                        <td>{eventdata?.extendedProps?.trainer ? eventdata?.extendedProps?.trainer : "UnKnown Name"}</td>
                                    </tr>
                                    <tr>
                                        <td>Slots</td>
                                        <td className="text-success">  {eventdata?.extendedProps?.slotsBooked}/{eventdata?.extendedProps?.slotsRemaining} Booked</td>
                                    </tr>
                                    <tr>
                                        <td>Location</td>
                                        <td>{eventdata?.extendedProps?.location}</td>
                                    </tr>
                                    <tr>
                                        <td>Session Type</td>
                                        <td > {eventdata?.extendedProps?.scheduleinfo?.isprivate ? "Private" : "Pubilc"}</td>
                                    </tr>

                                    <tr>
                                        <td> Cancellation Policy</td>
                                        <td>  <p className='mb-0 text-wrap'>
                                            {eventdata?.extendedProps?.cancellationPolicy && eventdata?.extendedProps?.cancellationPolicy.length > 0 ? (
                                                eventdata.extendedProps.cancellationPolicy.map(element => (
                                                    <p key={element._id} className='mb-0 text-wrap'>
                                                        {element.days} day(s) - {element.feevalue}% fee
                                                    </p>
                                                ))
                                            ) : (
                                                <p className="m-0">No cancellation policy available</p>
                                            )}
                                        </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td> Membership Discounts</td>
                                        <td>
                                            <div className=''>
                                                {eventdata?.extendedProps?.membershipdiscount && eventdata?.extendedProps?.membershipdiscount.length > 0
                                                    ? eventdata?.extendedProps?.membershipdiscount.map((item) => {
                                                        let planName = "Unknown Plan";

                                                        // Try to find the base plan first
                                                        let plan = plans.find((p) => p._id === item.membershipname);

                                                        // If not found, check inside subplans
                                                        if (!plan) {
                                                            for (const p of plans) {
                                                                if (p.subplans?.length > 0) {
                                                                    const subplan = p.subplans.find(sp => sp._id === item.membershipname);
                                                                    if (subplan) {
                                                                        plan = subplan;
                                                                        plan.parentName = p.name; // store parent name
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                        }

                                                        // Determine the display name
                                                        if (plan) {
                                                            if (plan.displayName) {
                                                                planName = plan.displayName;
                                                            } else if (plan.parentName) {
                                                                planName = `${plan.parentName} - ${plan.name}`;
                                                            } else {
                                                                planName = plan.name;
                                                            }
                                                        }

                                                        return (
                                                            <ul className="m-0 ps-3" key={item.membershipname}>
                                                                <li className="p-1">{planName} - {item.discount}%</li>
                                                            </ul>
                                                        );
                                                    })
                                                    : (
                                                        <p className="mb-0">No Membership Discounts available</p>
                                                    )}
                                            </div>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td> Description</td>
                                        <td><p className='mb-0 ms-2' title={stripHtmlTags(eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--")} dangerouslySetInnerHTML={{ __html: eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--" }} /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </MDBModalBody>

                        <MDBModalFooter className="px-3 pb-2">
                            <MDBBtn color='secondary' onClick={scheduleopen}>
                                Close
                            </MDBBtn>

                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setcopyLink(false)}
            >Link copied to clipboard!
            </MDBAlert>
            <MDBAlert
                color={linkstatus}
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={sendLink}
                onClose={() => setSendLink(false)}
            >{linkstatus == 'success' ? "Waiver send Successfully!" : "Waiver not send Successfully!"}
            </MDBAlert>
        </>
    );
};

export default ClassesBooking;
